export default __webpack_public_path__ + "static/media/analysis2.c8e34e54.svg";